module.exports = __webpack_public_path__ + "static/img/polarisTripRECbgEng.650987b.png";


//////////////////
// WEBPACK FOOTER
// ./static/bg/polarisTripRECbgEng.png
// module id = y6pO
// module chunks = 1